import { StyledProgressBar } from './StyledProgressBar';
import { useProgress } from './useProgress';

import type { ProgressBarProps } from './StyledProgressBar';

export const ProgressBar = (props: Omit<ProgressBarProps, 'progress'>): JSX.Element => {
  const progress = useProgress();

  return <StyledProgressBar {...(props as any)} progress={progress} />;
};
